	export const customSelectStyles2 = {
			control: (provided: any, state: { isFocused: any; }) => ({
				...provided,
				backgroundColor: '#fff',
				borderColor: state.isFocused ? '#b30000' : '#333',
				boxShadow: state.isFocused ? '0 0 0 1px #b30000' : 'none',
				'&:hover': {
					borderColor: '#b30000',
				},
			}),

			menu: (provided: any) => ({
				...provided,
				backgroundColor: '#fff',
				border: '1px solid #b30000',
				zIndex: 30,
			}),

			menuList: (provided: any) => ({
				...provided,
				backgroundColor: '#fff', 
			}),

			option: (provided: any, state: { isFocused: any; isSelected: any; }) => ({
				...provided,
				backgroundColor: state.isFocused
					? 'rgba(207, 0, 76, 0.2)'
					: state.isSelected
						? 'rgba(207, 0, 76, 0.2)'
						: '#fff',
				color: '#333',
				// color: state.isFocused || state.isSelected ? '#fff' : '#333',
				cursor: 'pointer',
				transition: 'background-color 0.2s ease',
			}),

			placeholder: (provided: any) => ({
				...provided,
				color: '#999',
			}),
		};